import React from 'react';
import { useTranslation } from 'react-i18next';

import './TaskDatesNav.styles.css';

const NavItem = ({ id, label, icon, current, hideOnLarge, onClick }) => {
    const handleClick = () => onClick(id);

    return (
        <div className={'horizontal-nav-item' + (current === id ? ' active' : '') + (hideOnLarge ? ' hide-on-large' : '')} data-text={label} onClick={handleClick}>
            { label }
        </div>
    )
}

const TaskDatesNav = ({ current, onClick }) => {
    const { t } = useTranslation(['common', 'recurring']);

    return (
        <div className="horizontal-nav task-dates-nav">
            <NavItem id="dueDate" label={ t('Due Date') } current={current} onClick={onClick} />

            <NavItem id="startDate" label={ t('Start Date') } current={current} onClick={onClick} />

            <NavItem id="reminder" label={ t('Reminder') } current={current} onClick={onClick} />

            <NavItem id="recurring" label={ t('recurring:Recurring') } current={current} onClick={onClick} />
        </div>
    )
}

export default TaskDatesNav;
